import React, { useEffect, useState } from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import yup from '../../../libs/yup/yup';
import Swal from 'sweetalert2';
import { Controller, useForm } from 'react-hook-form';
import CustomInput from '../../../components/input/CustomInput';
import { updateFacility } from '../../../api/sportaloka-client';
import Uploader from '../../../components/input/Uploader';

const defaultValues = {
  name: '',
  icon: ''
};

const schema = yup.object().shape({
  name: yup.string().label('Nama fasilitas').required('${label} wajib diisi'),
  icon: yup.string().label('Ikon').required('${label} wajib diisi')
});

function UpdateFacilityModal({ onSubmitted, data }) {
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (data) {
      setValue('name', data.name);
      setValue('icon', data.icon);
    }
  }, [data]);

  const {
    control,
    handleSubmit,
    reset,
    setValue,
    formState: { errors }
  } = useForm({
    defaultValues,
    mode: 'onChange',
    resolver: yupResolver(schema)
  });

  const onSubmit = async (val) => {
    try {
      setLoading(true);
      await updateFacility(data.id, val.name, val.icon);
      Swal.fire({
        title: 'Berhasil!',
        text: 'Fasilitas berhasil diperbarui',
        icon: 'success',
        confirmButtonText: 'Tutup'
      });
      reset();
      document.getElementById('closeModalUpdate').click();
      onSubmitted();
      setLoading(false);
    } catch (error) {
      if (error.response && error.response.status === 409) {
        Swal.fire({
          title: 'Gagal!',
          text: `Fasilitas '${val.name}' sudah ada di database`,
          icon: 'error',
          confirmButtonText: 'Tutup'
        });
      } else {
        Swal.fire({
          title: 'Gagal!',
          text: 'Periksa koneksi anda dan coba kembali.',
          icon: 'error',
          confirmButtonText: 'Tutup'
        });
      }
      setLoading(false);
    }
  };

  useEffect(() => {
    const handleModalHidden = () => {
      reset();
    };

    const modalElement = document.getElementById('updateFacilityModal');
    modalElement.addEventListener('hidden.bs.modal', handleModalHidden);

    return () => {
      modalElement.removeEventListener('hidden.bs.modal', handleModalHidden);
    };
  }, [reset]);

  return (
    <div className="modal" tabIndex="-1" id="updateFacilityModal">
      <div className="modal-dialog">
        <div className="modal-content">
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="modal-header">
              <h5 className="modal-title">Edit Fasilitas</h5>
              <button
                id="closeModalUpdate"
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"></button>
            </div>
            {data && (
              <div className="modal-body">
                <Controller
                  control={control}
                  name="name"
                  render={({ field: { onChange, onBlur, value } }) => (
                    <div className="mb-10">
                      <CustomInput
                        onChange={onChange}
                        onBlur={onBlur}
                        value={value}
                        type="text"
                        label="Nama Fasilitas"
                        isError={Boolean(errors.name)}
                        isSolid={true}
                        errorMessage={Boolean(errors.name) && errors.name.message}
                      />
                    </div>
                  )}
                />
                <Controller
                  control={control}
                  name="icon"
                  render={({ field: { onChange, onBlur, value } }) => (
                    <div className="mb-10">
                      <Uploader
                        onChange={onChange}
                        onBlur={onBlur}
                        value={value}
                        id="updateIcon"
                        accept="image/*"
                        path="facilities/"
                        type="text"
                        label="Ikon"
                        isError={Boolean(errors.icon)}
                        errorMessage={Boolean(errors.icon) && errors.icon.message}
                      />
                    </div>
                  )}
                />
              </div>
            )}
            {data && (
              <div className="modal-footer justify-content-center">
                <button
                  disabled={loading}
                  type="submit"
                  className="btn btn-primary bg-blue-1 rounded-1">
                  <i className="fa fa-save mr-10"></i>
                  <span className="fw-500">{loading ? 'Mohon tunggu...' : 'Simpan Perubahan'}</span>
                </button>
              </div>
            )}
          </form>
        </div>
      </div>
    </div>
  );
}

export default UpdateFacilityModal;
